import React from 'react';
import { render, screen, fireEvent } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';
import UserMenu from 'components/layouts/ManagementLayout/UserMenu';

const PROPS = {
  email: 'mtapajos@decisiv.com',
  logoutPath: '/users/logout',
  name: 'Marcos Tapajos',
  profilePath: '/users/edit/374065',
  roleLabel: 'Global Admin',
};

const renderUserMenu = (props = {}) =>
  render(
    <ConfigProvider>
      <UserMenu {...PROPS} {...props} />
    </ConfigProvider>,
  );

const openMenu = () =>
  fireEvent.click(screen.getByRole('button', { name: /Marcos Tapajos/i }));

describe('UserMenu', () => {
  it('shows the user name on the trigger', () => {
    renderUserMenu();

    expect(
      screen.getByRole('button', { name: /Marcos Tapajos/i }),
    ).toBeInTheDocument();
  });

  it('falls back to the email when there is no name', () => {
    renderUserMenu({ name: undefined });

    expect(
      screen.getByRole('button', { name: /mtapajos@decisiv\.com/i }),
    ).toBeInTheDocument();
  });

  it('shows the email and role in the open menu', () => {
    renderUserMenu();
    openMenu();

    expect(screen.getByText('mtapajos@decisiv.com')).toBeInTheDocument();
    expect(screen.getByText('Global Admin')).toBeInTheDocument();
  });

  it('links to the profile and logout paths', () => {
    renderUserMenu();
    openMenu();

    expect(screen.getByText('My Profile').closest('a')).toHaveAttribute(
      'href',
      '/users/edit/374065',
    );
    expect(screen.getByText('Log Out').closest('a')).toHaveAttribute(
      'href',
      '/users/logout',
    );
  });

  it('omits My Profile when no profile path is available', () => {
    renderUserMenu({ profilePath: undefined });
    openMenu();

    expect(screen.queryByText('My Profile')).not.toBeInTheDocument();
    expect(screen.getByText('Log Out')).toBeInTheDocument();
  });

  it('omits the role tag when there is no role label', () => {
    renderUserMenu({ roleLabel: undefined });
    openMenu();

    expect(screen.queryByText('Global Admin')).not.toBeInTheDocument();
  });
});
